module.exports = __webpack_public_path__ + "static/img/6_2_2.12ec08b3.jpg";